import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

export const BackChevron = ({ onClick }) => {
  const chevronIcon = useSelector(state => state.asset?.top_head_option_back);

  return (
    <div className="QRLinkingPaymentMethod-back-chevron">
      <img src={chevronIcon} alt="" onClick={onClick} />
    </div>
  );
};

export default BackChevron;
